import { FaAmbulance, FaHeartbeat, FaPlane, FaTrain, FaCalendar, FaUsers, FaIndustry} from 'react-icons/fa';

export const ambulanceServices = [
  {
    title: "Emergency & Medical Assistance",
    description:
      "Our 24/7 Emergency Ambulance Service offers rapid, reliable transport for any urgent medical case, backed by professional paramedics and advanced vehicles. Alongside, our Medical Assistance team provides comprehensive support throughout patient transfers, ensuring safety and comfort every step of the way.",
    icon: <FaAmbulance className="text-red-600" />,
    badge: "24/7 Emergency",
    image: "/assets/servicesPage/services/emerge3.png",
  },
  {
    title: "ICU Ambulance Service",
    description:
      "Specialized ICU Ambulances equipped with state-of-the-art critical care facilities and staffed by expert medical personnel for high-risk patient transfers. Trust us to provide seamless and safe transport during critical emergencies with full life-support systems at hand.",
    icon: <FaHeartbeat className="text-pink-600" />,
    badge: "Critical Care",
    image: "/assets/servicesPage/services/icu-ambulance3.png",
  },
  {
    title: "Flight & Train Ambulance",
    description:
      "We arrange efficient ambulance transfer via air and rail for patients requiring urgent or long-distance medical transport. Coordinated with airports and railway stations, our service ensures smooth transitions and continuous care during every leg of the journey.",
    icon: (
      <>
        <FaPlane className="text-blue-600 mr-1" />
        <FaTrain className="text-gray-700" />
      </>
    ),
    badge: "Expedited Transport",
    image: "/assets/servicesPage/services/flight-train-ambulance3.png",
  },
  {
    title: "Scheduled Patient Transport",
    description:
      "Plan your hospital visits or intercity transfers with our Safe and Organized Scheduled Patient Transport service. We prioritize punctuality, comfort, and safety, making hospital journeys stress-free and reliable for patients and families alike.",
    icon: <FaCalendar className="text-red-400" />,
    badge: "Planned & Reliable",
    image: "/assets/servicesPage/services/scheduled-transport3.png",
  },
  {
    title: "Corpse Transport & Freezer Box Facilities",
    description:
      "We provide dignified and secure corpse transportation services utilizing refrigerated freezer boxes to maintain respect and meet regulatory standards. Our professional team handles every transfer sensitively to ease difficult times.",
    icon: <FaAmbulance className="text-gray-600" />,
    badge: "Respect & Care",
    image: "/assets/servicesPage/services/corpse-transport3.png",
  },
  {
    title: "Event Ambulance Services",
    description:
      "Ensure safety at your major events with our specialized ambulance services tailored for large gatherings. Our ambulances are equipped for rapid emergency response at sports, concerts, festivals, and other events, protecting lives efficiently.",
    icon: <FaUsers className="text-green-600" />,
    badge: "Event Safety",
    image: "/assets/servicesPage/services/event-ambulance3.png",
  },
  {
    title: "Corporate & Industrial Ambulance Services",
    description:
      "Dedicated ambulance services to business campuses, tech parks, and industrial zones, providing ready emergency response and health services on site. We tailor our facilities to industry-specific needs, ensuring workplace safety is never compromised.",
    icon: <FaIndustry className="text-yellow-600" />,
    badge: "Workplace Safety",
    image: "/assets/servicesPage/services/corporate-industrial3.png",
  },
];
